module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz84aGhmk9AP8EAf8BAP8CAf8AADUkADUcED0YDCAcABQcAFEEBBwQCCQMABQQAD0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABkALAAAAAAgACAAAAW6YCaOZIadaIoBZeuamCHP8/neYkzvhoDhLh1v9wOWhMOa8VhTnWTFZc6AgVCcz6g0prJUUlTpKIvlapeoJNUmhl3UGMnZeKrAr21YA84WP9VreX98ghgLcBBzQCcKcHJiAXpwXxmRRgEBGBFIRCeYUplvgJ5tWQcODwgJCRYUgaVrZXaKODoYXykSorQ3SBIMDBISNLwvnEnFQYBKsMthzcvJLVEFPGN5GRMiA9zdAznYItpDJuFjZUAhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadS_S6.gif
// module id = +A4O
// module chunks = 48